var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.78 3.907 12.315.26a.585.585 0 0 0-.533-.258.583.583 0 0 0-.49.33l-.483.994-.355-.174a7.255 7.255 0 0 0-5.57-.301C3.099 1.485 1.682 2.76.9 4.443c-1.606 3.448-.128 7.605 3.292 9.27a7.016 7.016 0 0 0 8.701-2.122 1.06 1.06 0 0 0 .18-.887 1.063 1.063 0 0 0-.569-.706l-.058-.03a1.077 1.077 0 0 0-1.329.335 4.834 4.834 0 0 1-5.963 1.436C2.801 10.596 1.786 7.737 2.89 5.366a4.722 4.722 0 0 1 2.735-2.46 5.01 5.01 0 0 1 3.85.209l.375.183-.483.993a.585.585 0 0 0 .042.59.587.587 0 0 0 .533.261l4.392-.31a.583.583 0 0 0 .49-.332.585.585 0 0 0-.042-.59l-.002-.003z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.6b3551dd8b0a9a571bb91c742651362a.svg";
export { ForwardRef as ReactComponent };